export type WireTemplateStatus = 'Pending Approval' | 'Approval Rejected' | 'Ready';

export const wireTemplateStatuses: WireTemplateStatus[] = [
    'Pending Approval',
    'Approval Rejected',
    'Ready',
];
